/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDgtPdProductionOrder = /* GraphQL */ `
  query GetDgtPdProductionOrder($id: ID!) {
    getDgtPdProductionOrder(id: $id) {
      id
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      dueDate
      actualDueDate
      batchNumbers
      actualBatchNumbers
      trialBatch
      statusFromSap
      statusFromApp
      countEditWorkCenter
      countEditOperation
      releaseNo
      releasedBy
      totalYield
      division
      _ttl
      tags
      createdAt
      updatedAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      orderType
      fgInspectionTypes
      infoEaPerPack
      shelfLife
      barcodeEa
      alternativeText
      shelfLifeMonth
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdProductionOrders = /* GraphQL */ `
  query ListDgtPdProductionOrders(
    $filter: ModelDgtPdProductionOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdProductionOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        dueDate
        actualDueDate
        batchNumbers
        actualBatchNumbers
        trialBatch
        statusFromSap
        statusFromApp
        countEditWorkCenter
        countEditOperation
        releaseNo
        releasedBy
        totalYield
        division
        _ttl
        tags
        createdAt
        updatedAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        orderType
        fgInspectionTypes
        infoEaPerPack
        shelfLife
        barcodeEa
        alternativeText
        shelfLifeMonth
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdProductionOrders = /* GraphQL */ `
  query SyncDgtPdProductionOrders(
    $filter: ModelDgtPdProductionOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdProductionOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        dueDate
        actualDueDate
        batchNumbers
        actualBatchNumbers
        trialBatch
        statusFromSap
        statusFromApp
        countEditWorkCenter
        countEditOperation
        releaseNo
        releasedBy
        totalYield
        division
        _ttl
        tags
        createdAt
        updatedAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        orderType
        fgInspectionTypes
        infoEaPerPack
        shelfLife
        barcodeEa
        alternativeText
        shelfLifeMonth
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const orderByStatusAndDueDate = /* GraphQL */ `
  query OrderByStatusAndDueDate(
    $statusFromApp: String!
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdProductionOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderByStatusAndDueDate(
      statusFromApp: $statusFromApp
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        dueDate
        actualDueDate
        batchNumbers
        actualBatchNumbers
        trialBatch
        statusFromSap
        statusFromApp
        countEditWorkCenter
        countEditOperation
        releaseNo
        releasedBy
        totalYield
        division
        _ttl
        tags
        createdAt
        updatedAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        orderType
        fgInspectionTypes
        infoEaPerPack
        shelfLife
        barcodeEa
        alternativeText
        shelfLifeMonth
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const orderByTypeSortByDate = /* GraphQL */ `
  query OrderByTypeSortByDate(
    $orderType: OrderType!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdProductionOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderByTypeSortByDate(
      orderType: $orderType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        dueDate
        actualDueDate
        batchNumbers
        actualBatchNumbers
        trialBatch
        statusFromSap
        statusFromApp
        countEditWorkCenter
        countEditOperation
        releaseNo
        releasedBy
        totalYield
        division
        _ttl
        tags
        createdAt
        updatedAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        orderType
        fgInspectionTypes
        infoEaPerPack
        shelfLife
        barcodeEa
        alternativeText
        shelfLifeMonth
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderOperation = /* GraphQL */ `
  query GetDgtPdOrderOperation($id: ID!) {
    getDgtPdOrderOperation(id: $id) {
      id
      productionOrderId
      operationNo
      workCenterId
      workCenterDescription
      actualWorkCenterId
      actualWorkCenterDescription
      status
      active
      createdBySystem
      draftedDate
      draftedBy
      confirmedDate
      confirmedBy
      confirmationId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderOperations = /* GraphQL */ `
  query ListDgtPdOrderOperations(
    $filter: ModelDgtPdOrderOperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdOrderOperations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        operationNo
        workCenterId
        workCenterDescription
        actualWorkCenterId
        actualWorkCenterDescription
        status
        active
        createdBySystem
        draftedDate
        draftedBy
        confirmedDate
        confirmedBy
        confirmationId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderOperations = /* GraphQL */ `
  query SyncDgtPdOrderOperations(
    $filter: ModelDgtPdOrderOperationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderOperations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productionOrderId
        operationNo
        workCenterId
        workCenterDescription
        actualWorkCenterId
        actualWorkCenterDescription
        status
        active
        createdBySystem
        draftedDate
        draftedBy
        confirmedDate
        confirmedBy
        confirmationId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const operationByOrderIdAndNo = /* GraphQL */ `
  query OperationByOrderIdAndNo(
    $productionOrderId: String!
    $operationNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderOperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationByOrderIdAndNo(
      productionOrderId: $productionOrderId
      operationNo: $operationNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        operationNo
        workCenterId
        workCenterDescription
        actualWorkCenterId
        actualWorkCenterDescription
        status
        active
        createdBySystem
        draftedDate
        draftedBy
        confirmedDate
        confirmedBy
        confirmationId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderOperationLog = /* GraphQL */ `
  query GetDgtPdOrderOperationLog($id: ID!) {
    getDgtPdOrderOperationLog(id: $id) {
      id
      timeType
      productionOrderId
      operationNo
      batchNo
      postingDate
      workCenterId
      workCenterDescription
      actualWorkCenterId
      shift
      mch
      startedTime
      finishedTime
      totalTime
      totalEmployeeRT
      totalEmployeeOT
      laborTimeRT
      laborTimeOT
      yield
      scrap
      bulkUsedQty
      downtimeCode
      downtimeDescription
      downtimeBaseTime
      reasonCode
      reasonDescription
      workingStatus
      pdOrderOperationId
      _ttl
      createdBy
      createdAt
      updatedBy
      updatedAt
      split
      confirmedDate
      confirmedBy
      confirmationId
      bulkStatus
      bulkStatusDate
      bulkStatusDateTime
      bulkStatusBy
      bulkStatusComment
      approveBulkStatusDate
      approveBulkStatusDateTime
      approveBulkStatusBy
      createdVersion
      updatedVersion
      materialCode
      materialDescription
      orderType
      orderQty
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderOperationLogs = /* GraphQL */ `
  query ListDgtPdOrderOperationLogs(
    $filter: ModelDgtPdOrderOperationLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdOrderOperationLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timeType
        productionOrderId
        operationNo
        batchNo
        postingDate
        workCenterId
        workCenterDescription
        actualWorkCenterId
        shift
        mch
        startedTime
        finishedTime
        totalTime
        totalEmployeeRT
        totalEmployeeOT
        laborTimeRT
        laborTimeOT
        yield
        scrap
        bulkUsedQty
        downtimeCode
        downtimeDescription
        downtimeBaseTime
        reasonCode
        reasonDescription
        workingStatus
        pdOrderOperationId
        _ttl
        createdBy
        createdAt
        updatedBy
        updatedAt
        split
        confirmedDate
        confirmedBy
        confirmationId
        bulkStatus
        bulkStatusDate
        bulkStatusDateTime
        bulkStatusBy
        bulkStatusComment
        approveBulkStatusDate
        approveBulkStatusDateTime
        approveBulkStatusBy
        createdVersion
        updatedVersion
        materialCode
        materialDescription
        orderType
        orderQty
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderOperationLogs = /* GraphQL */ `
  query SyncDgtPdOrderOperationLogs(
    $filter: ModelDgtPdOrderOperationLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderOperationLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        timeType
        productionOrderId
        operationNo
        batchNo
        postingDate
        workCenterId
        workCenterDescription
        actualWorkCenterId
        shift
        mch
        startedTime
        finishedTime
        totalTime
        totalEmployeeRT
        totalEmployeeOT
        laborTimeRT
        laborTimeOT
        yield
        scrap
        bulkUsedQty
        downtimeCode
        downtimeDescription
        downtimeBaseTime
        reasonCode
        reasonDescription
        workingStatus
        pdOrderOperationId
        _ttl
        createdBy
        createdAt
        updatedBy
        updatedAt
        split
        confirmedDate
        confirmedBy
        confirmationId
        bulkStatus
        bulkStatusDate
        bulkStatusDateTime
        bulkStatusBy
        bulkStatusComment
        approveBulkStatusDate
        approveBulkStatusDateTime
        approveBulkStatusBy
        createdVersion
        updatedVersion
        materialCode
        materialDescription
        orderType
        orderQty
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const operationLogByOrderIdAndNo = /* GraphQL */ `
  query OperationLogByOrderIdAndNo(
    $productionOrderId: String!
    $operationNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderOperationLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationLogByOrderIdAndNo(
      productionOrderId: $productionOrderId
      operationNo: $operationNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timeType
        productionOrderId
        operationNo
        batchNo
        postingDate
        workCenterId
        workCenterDescription
        actualWorkCenterId
        shift
        mch
        startedTime
        finishedTime
        totalTime
        totalEmployeeRT
        totalEmployeeOT
        laborTimeRT
        laborTimeOT
        yield
        scrap
        bulkUsedQty
        downtimeCode
        downtimeDescription
        downtimeBaseTime
        reasonCode
        reasonDescription
        workingStatus
        pdOrderOperationId
        _ttl
        createdBy
        createdAt
        updatedBy
        updatedAt
        split
        confirmedDate
        confirmedBy
        confirmationId
        bulkStatus
        bulkStatusDate
        bulkStatusDateTime
        bulkStatusBy
        bulkStatusComment
        approveBulkStatusDate
        approveBulkStatusDateTime
        approveBulkStatusBy
        createdVersion
        updatedVersion
        materialCode
        materialDescription
        orderType
        orderQty
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const operationLogByOrderIdAndLot = /* GraphQL */ `
  query OperationLogByOrderIdAndLot(
    $productionOrderId: String!
    $batchNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderOperationLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationLogByOrderIdAndLot(
      productionOrderId: $productionOrderId
      batchNo: $batchNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timeType
        productionOrderId
        operationNo
        batchNo
        postingDate
        workCenterId
        workCenterDescription
        actualWorkCenterId
        shift
        mch
        startedTime
        finishedTime
        totalTime
        totalEmployeeRT
        totalEmployeeOT
        laborTimeRT
        laborTimeOT
        yield
        scrap
        bulkUsedQty
        downtimeCode
        downtimeDescription
        downtimeBaseTime
        reasonCode
        reasonDescription
        workingStatus
        pdOrderOperationId
        _ttl
        createdBy
        createdAt
        updatedBy
        updatedAt
        split
        confirmedDate
        confirmedBy
        confirmationId
        bulkStatus
        bulkStatusDate
        bulkStatusDateTime
        bulkStatusBy
        bulkStatusComment
        approveBulkStatusDate
        approveBulkStatusDateTime
        approveBulkStatusBy
        createdVersion
        updatedVersion
        materialCode
        materialDescription
        orderType
        orderQty
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const orderLogByBulkStatusDate = /* GraphQL */ `
  query OrderLogByBulkStatusDate(
    $bulkStatusDate: AWSDate!
    $bulkStatusDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderOperationLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderLogByBulkStatusDate(
      bulkStatusDate: $bulkStatusDate
      bulkStatusDateTime: $bulkStatusDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timeType
        productionOrderId
        operationNo
        batchNo
        postingDate
        workCenterId
        workCenterDescription
        actualWorkCenterId
        shift
        mch
        startedTime
        finishedTime
        totalTime
        totalEmployeeRT
        totalEmployeeOT
        laborTimeRT
        laborTimeOT
        yield
        scrap
        bulkUsedQty
        downtimeCode
        downtimeDescription
        downtimeBaseTime
        reasonCode
        reasonDescription
        workingStatus
        pdOrderOperationId
        _ttl
        createdBy
        createdAt
        updatedBy
        updatedAt
        split
        confirmedDate
        confirmedBy
        confirmationId
        bulkStatus
        bulkStatusDate
        bulkStatusDateTime
        bulkStatusBy
        bulkStatusComment
        approveBulkStatusDate
        approveBulkStatusDateTime
        approveBulkStatusBy
        createdVersion
        updatedVersion
        materialCode
        materialDescription
        orderType
        orderQty
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderReasonCode = /* GraphQL */ `
  query GetDgtPdOrderReasonCode($id: ID!) {
    getDgtPdOrderReasonCode(id: $id) {
      id
      productionOrderId
      releaseNo
      materialCode
      labOffice
      materialDescription
      unit
      reasonCodes
      confirmedDate
      confirmedBy
      confirmStatus
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderReasonCodes = /* GraphQL */ `
  query ListDgtPdOrderReasonCodes(
    $filter: ModelDgtPdOrderReasonCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdOrderReasonCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        releaseNo
        materialCode
        labOffice
        materialDescription
        unit
        reasonCodes
        confirmedDate
        confirmedBy
        confirmStatus
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderReasonCodes = /* GraphQL */ `
  query SyncDgtPdOrderReasonCodes(
    $filter: ModelDgtPdOrderReasonCodeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderReasonCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productionOrderId
        releaseNo
        materialCode
        labOffice
        materialDescription
        unit
        reasonCodes
        confirmedDate
        confirmedBy
        confirmStatus
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reasonCodesByOrderId = /* GraphQL */ `
  query ReasonCodesByOrderId(
    $productionOrderId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReasonCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reasonCodesByOrderId(
      productionOrderId: $productionOrderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        releaseNo
        materialCode
        labOffice
        materialDescription
        unit
        reasonCodes
        confirmedDate
        confirmedBy
        confirmStatus
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdDowntimeCode = /* GraphQL */ `
  query GetDgtPdDowntimeCode($id: ID!) {
    getDgtPdDowntimeCode(id: $id) {
      id
      description
      active
      baseTimeForBulk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdDowntimeCodes = /* GraphQL */ `
  query ListDgtPdDowntimeCodes(
    $filter: ModelDgtPdDowntimeCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdDowntimeCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        active
        baseTimeForBulk
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdDowntimeCodes = /* GraphQL */ `
  query SyncDgtPdDowntimeCodes(
    $filter: ModelDgtPdDowntimeCodeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdDowntimeCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        description
        active
        baseTimeForBulk
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdWorkCenter = /* GraphQL */ `
  query GetDgtPdWorkCenter($id: ID!) {
    getDgtPdWorkCenter(id: $id) {
      id
      plant
      description
      active
      iotId
      isRequiredManHour
      isRequiredBatchLotNo
      isRequiredFGInspect
      machineCategory
      sapCategoryCode
      sapCategoryName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdWorkCenters = /* GraphQL */ `
  query ListDgtPdWorkCenters(
    $filter: ModelDgtPdWorkCenterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdWorkCenters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        plant
        description
        active
        iotId
        isRequiredManHour
        isRequiredBatchLotNo
        isRequiredFGInspect
        machineCategory
        sapCategoryCode
        sapCategoryName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdWorkCenters = /* GraphQL */ `
  query SyncDgtPdWorkCenters(
    $filter: ModelDgtPdWorkCenterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdWorkCenters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        plant
        description
        active
        iotId
        isRequiredManHour
        isRequiredBatchLotNo
        isRequiredFGInspect
        machineCategory
        sapCategoryCode
        sapCategoryName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderPicklist = /* GraphQL */ `
  query GetDgtPdOrderPicklist($pk: ID!, $sk: ID!) {
    getDgtPdOrderPicklist(pk: $pk, sk: $sk) {
      pk
      sk
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      division
      kiNo
      batchLotNo
      trialBatch
      status
      returnStatus
      releasedDate
      releasedBy
      requestQty
      requestedDate
      requestedDateTime
      requestedBy
      withdrawQty
      draftedDate
      draftedBy
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      usedGoodQty
      usedWasteQty
      recordedDate
      recordedDateTime
      recordedBy
      completedDate
      completedDateTime
      completedBy
      returnGoodQty
      returnWasteQty
      receivedReturnDateTime
      receivedReturnBy
      commentText
      commentedBy
      commentActive
      id
      extraReturnId
      deprecated
      shortageItems
      externalBom
      createdAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      barcodePkg
      orderType
      receiveDate
      barcodeEa
      alternativeText
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderPicklists = /* GraphQL */ `
  query ListDgtPdOrderPicklists(
    $pk: ID
    $sk: ModelIDKeyConditionInput
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdOrderPicklists(
      pk: $pk
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderPicklists = /* GraphQL */ `
  query SyncDgtPdOrderPicklists(
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderPicklists(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByDivisionAndType = /* GraphQL */ `
  query PicklistByDivisionAndType(
    $division: String!
    $materialType: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByDivisionAndType(
      division: $division
      materialType: $materialType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByReleaseDate = /* GraphQL */ `
  query PicklistByReleaseDate(
    $releasedDate: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByReleaseDate(
      releasedDate: $releasedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByRequestedDate = /* GraphQL */ `
  query PicklistByRequestedDate(
    $requestedDate: AWSDate!
    $requestedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByRequestedDate(
      requestedDate: $requestedDate
      requestedDateTime: $requestedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByRequestedDateType = /* GraphQL */ `
  query PicklistByRequestedDateType(
    $requestedDate: AWSDate!
    $divisionOrderTypeStatus: ModelDgtPdOrderPicklistByRequestedDateAndOrdTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByRequestedDateType(
      requestedDate: $requestedDate
      divisionOrderTypeStatus: $divisionOrderTypeStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByApprovedDate = /* GraphQL */ `
  query PicklistByApprovedDate(
    $approvedDate: AWSDate!
    $approvedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByApprovedDate(
      approvedDate: $approvedDate
      approvedDateTime: $approvedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByCheckedDate = /* GraphQL */ `
  query PicklistByCheckedDate(
    $checkedDate: AWSDate!
    $checkedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByCheckedDate(
      checkedDate: $checkedDate
      checkedDateTime: $checkedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByQualityChecked = /* GraphQL */ `
  query PicklistByQualityChecked(
    $qualityCheckedDate: AWSDate!
    $qualityCheckedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByQualityChecked(
      qualityCheckedDate: $qualityCheckedDate
      qualityCheckedDateTime: $qualityCheckedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByRecordedDate = /* GraphQL */ `
  query PicklistByRecordedDate(
    $recordedDate: AWSDate!
    $recordedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByRecordedDate(
      recordedDate: $recordedDate
      recordedDateTime: $recordedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const picklistByCompletedDate = /* GraphQL */ `
  query PicklistByCompletedDate(
    $completedDate: AWSDate!
    $completedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    picklistByCompletedDate(
      completedDate: $completedDate
      completedDateTime: $completedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        materialType
        materialCode
        materialDescription
        materialMrp
        orderQty
        materialUnit
        division
        kiNo
        batchLotNo
        trialBatch
        status
        returnStatus
        releasedDate
        releasedBy
        requestQty
        requestedDate
        requestedDateTime
        requestedBy
        withdrawQty
        draftedDate
        draftedBy
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        usedGoodQty
        usedWasteQty
        recordedDate
        recordedDateTime
        recordedBy
        completedDate
        completedDateTime
        completedBy
        returnGoodQty
        returnWasteQty
        receivedReturnDateTime
        receivedReturnBy
        commentText
        commentedBy
        commentActive
        id
        extraReturnId
        deprecated
        shortageItems
        externalBom
        createdAt
        infoEffBulkDate
        infoFwt
        infoPallet
        infoRefPkg
        infoPacking
        barcodeFgCase
        barcodePkg
        orderType
        receiveDate
        barcodeEa
        alternativeText
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderPicklistMovement = /* GraphQL */ `
  query GetDgtPdOrderPicklistMovement($orderId: ID!, $sk: ID!) {
    getDgtPdOrderPicklistMovement(orderId: $orderId, sk: $sk) {
      orderId
      sk
      materialCode
      materialDescription
      materialUnit
      materialType
      materialRequestQty
      documentYear
      documentNo
      documentItemNo
      documentCreatedAt
      movementType
      amount
      batchLotNo
      plant
      postingDate
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      id
      division
      usedGoodQty
      usedWasteQty
      returnGoodQty
      returnGoodShrinkQty
      returnWasteQty
      recordedDateTime
      recordedBy
      returnRefId
      extraRefId
      canceledDateTime
      canceledBy
      bulkUsedLogs
      wasteRecordedDate
      wasteRecordedDateTime
      wasteRecordedBy
      wasteRecordedStatus
      approvedWasteReturnDate
      approvedWasteReturnDateTime
      approvedWasteReturnBy
      otherQty
      vendorLotNo
      returnReasonCode
      returnReasonDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderPicklistMovements = /* GraphQL */ `
  query ListDgtPdOrderPicklistMovements(
    $orderId: ID
    $sk: ModelIDKeyConditionInput
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdOrderPicklistMovements(
      orderId: $orderId
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderPicklistMovements = /* GraphQL */ `
  query SyncDgtPdOrderPicklistMovements(
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderPicklistMovements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByApprovedDate = /* GraphQL */ `
  query MovementsByApprovedDate(
    $approvedDate: AWSDate!
    $approvedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByApprovedDate(
      approvedDate: $approvedDate
      approvedDateTime: $approvedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByCheckedDate = /* GraphQL */ `
  query MovementsByCheckedDate(
    $checkedDate: AWSDate!
    $checkedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByCheckedDate(
      checkedDate: $checkedDate
      checkedDateTime: $checkedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByQualityChecked = /* GraphQL */ `
  query MovementsByQualityChecked(
    $qualityCheckedDate: AWSDate!
    $qualityCheckedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByQualityChecked(
      qualityCheckedDate: $qualityCheckedDate
      qualityCheckedDateTime: $qualityCheckedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByDivision = /* GraphQL */ `
  query MovementsByDivision(
    $division: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByDivision(
      division: $division
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByWasteRecorded = /* GraphQL */ `
  query MovementsByWasteRecorded(
    $wasteRecordedDate: AWSDate!
    $wasteRecordedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByWasteRecorded(
      wasteRecordedDate: $wasteRecordedDate
      wasteRecordedDateTime: $wasteRecordedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const movementsByApprovedWasteReturn = /* GraphQL */ `
  query MovementsByApprovedWasteReturn(
    $approvedWasteReturnDate: AWSDate!
    $approvedWasteReturnDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movementsByApprovedWasteReturn(
      approvedWasteReturnDate: $approvedWasteReturnDate
      approvedWasteReturnDateTime: $approvedWasteReturnDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderId
        sk
        materialCode
        materialDescription
        materialUnit
        materialType
        materialRequestQty
        documentYear
        documentNo
        documentItemNo
        documentCreatedAt
        movementType
        amount
        batchLotNo
        plant
        postingDate
        approvedDate
        approvedDateTime
        approvedBy
        checkedDate
        checkedDateTime
        checkedBy
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        id
        division
        usedGoodQty
        usedWasteQty
        returnGoodQty
        returnGoodShrinkQty
        returnWasteQty
        recordedDateTime
        recordedBy
        returnRefId
        extraRefId
        canceledDateTime
        canceledBy
        bulkUsedLogs
        wasteRecordedDate
        wasteRecordedDateTime
        wasteRecordedBy
        wasteRecordedStatus
        approvedWasteReturnDate
        approvedWasteReturnDateTime
        approvedWasteReturnBy
        otherQty
        vendorLotNo
        returnReasonCode
        returnReasonDescription
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderPicklistExtraReturn = /* GraphQL */ `
  query GetDgtPdOrderPicklistExtraReturn($id: ID!) {
    getDgtPdOrderPicklistExtraReturn(id: $id) {
      id
      orderId
      orderInfo
      requestMaterialType
      kiNo
      type
      status
      requestedDate
      requestedBy
      requestedDateTime
      approvedDate
      approvedBy
      approvedDateTime
      canceledDate
      canceledBy
      canceledDateTime
      withdrawedDate
      withdrawedBy
      withdrawedDateTime
      checkedDate
      checkedBy
      checkedDateTime
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      remark
      items
      extraReturnItems {
        items {
          id
          extraReturnId
          orderId
          materialCode
          materialDescription
          materialUnit
          batchLotNo
          qty
          withShQty
          wasteQty
          remark
          returnStorageLocation
          returnReasonCode
          returnReasonDescription
          active
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      documentNo
      documentYear
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderPicklistExtraReturns = /* GraphQL */ `
  query ListDgtPdOrderPicklistExtraReturns(
    $id: ID
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdOrderPicklistExtraReturns(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderPicklistExtraReturns = /* GraphQL */ `
  query SyncDgtPdOrderPicklistExtraReturns(
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderPicklistExtraReturns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByOrderId = /* GraphQL */ `
  query ExtraReturnByOrderId(
    $orderId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByOrderId(
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByTypeAndStatus = /* GraphQL */ `
  query ExtraReturnByTypeAndStatus(
    $type: ExtraReturnType!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByTypeAndStatus(
      type: $type
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByRequestedDate = /* GraphQL */ `
  query ExtraReturnByRequestedDate(
    $requestedDate: AWSDate!
    $requestedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByRequestedDate(
      requestedDate: $requestedDate
      requestedDateTime: $requestedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByApprovedDate = /* GraphQL */ `
  query ExtraReturnByApprovedDate(
    $approvedDate: AWSDate!
    $approvedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByApprovedDate(
      approvedDate: $approvedDate
      approvedDateTime: $approvedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByApprovedDateTypeStatus = /* GraphQL */ `
  query ExtraReturnByApprovedDateTypeStatus(
    $approvedDate: AWSDate!
    $typeStatus: ModelDgtPdOrderPicklistExtraReturnByApprovedDateTypeStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByApprovedDateTypeStatus(
      approvedDate: $approvedDate
      typeStatus: $typeStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByCanceledDate = /* GraphQL */ `
  query ExtraReturnByCanceledDate(
    $canceledDate: AWSDate!
    $canceledDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByCanceledDate(
      canceledDate: $canceledDate
      canceledDateTime: $canceledDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByWithdrawedDate = /* GraphQL */ `
  query ExtraReturnByWithdrawedDate(
    $withdrawedDate: AWSDate!
    $withdrawedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByWithdrawedDate(
      withdrawedDate: $withdrawedDate
      withdrawedDateTime: $withdrawedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByCheckedDate = /* GraphQL */ `
  query ExtraReturnByCheckedDate(
    $checkedDate: AWSDate!
    $checkedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByCheckedDate(
      checkedDate: $checkedDate
      checkedDateTime: $checkedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const extraReturnByQualityChecked = /* GraphQL */ `
  query ExtraReturnByQualityChecked(
    $qualityCheckedDate: AWSDate!
    $qualityCheckedDateTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderPicklistExtraReturnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    extraReturnByQualityChecked(
      qualityCheckedDate: $qualityCheckedDate
      qualityCheckedDateTime: $qualityCheckedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        orderInfo
        requestMaterialType
        kiNo
        type
        status
        requestedDate
        requestedBy
        requestedDateTime
        approvedDate
        approvedBy
        approvedDateTime
        canceledDate
        canceledBy
        canceledDateTime
        withdrawedDate
        withdrawedBy
        withdrawedDateTime
        checkedDate
        checkedBy
        checkedDateTime
        qualityCheckedDate
        qualityCheckedDateTime
        qualityCheckedBy
        remark
        items
        extraReturnItems {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        documentNo
        documentYear
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderPicklistExtraReturnItem = /* GraphQL */ `
  query GetDgtPdOrderPicklistExtraReturnItem($id: ID!) {
    getDgtPdOrderPicklistExtraReturnItem(id: $id) {
      id
      extraReturnId
      orderId
      materialCode
      materialDescription
      materialUnit
      batchLotNo
      qty
      withShQty
      wasteQty
      remark
      returnStorageLocation
      returnReasonCode
      returnReasonDescription
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderPicklistExtraReturnItems = /* GraphQL */ `
  query ListDgtPdOrderPicklistExtraReturnItems(
    $id: ID
    $filter: ModelDgtPdOrderPicklistExtraReturnItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdOrderPicklistExtraReturnItems(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        extraReturnId
        orderId
        materialCode
        materialDescription
        materialUnit
        batchLotNo
        qty
        withShQty
        wasteQty
        remark
        returnStorageLocation
        returnReasonCode
        returnReasonDescription
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderPicklistExtraReturnItems = /* GraphQL */ `
  query SyncDgtPdOrderPicklistExtraReturnItems(
    $filter: ModelDgtPdOrderPicklistExtraReturnItemFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderPicklistExtraReturnItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        extraReturnId
        orderId
        materialCode
        materialDescription
        materialUnit
        batchLotNo
        qty
        withShQty
        wasteQty
        remark
        returnStorageLocation
        returnReasonCode
        returnReasonDescription
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdIAMUser = /* GraphQL */ `
  query GetDgtPdIAMUser($username: ID!) {
    getDgtPdIAMUser(username: $username) {
      username
      employeeNo
      email
      firstName
      lastName
      department
      division
      line
      roles
      active
      id
      isAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdIAMUsers = /* GraphQL */ `
  query ListDgtPdIAMUsers(
    $username: ID
    $filter: ModelDgtPdIAMUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdIAMUsers(
      username: $username
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        username
        employeeNo
        email
        firstName
        lastName
        department
        division
        line
        roles
        active
        id
        isAdmin
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdIAMUsers = /* GraphQL */ `
  query SyncDgtPdIAMUsers(
    $filter: ModelDgtPdIAMUserFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdIAMUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        username
        employeeNo
        email
        firstName
        lastName
        department
        division
        line
        roles
        active
        id
        isAdmin
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const userByDepartment = /* GraphQL */ `
  query UserByDepartment(
    $department: Department!
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdIAMUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByDepartment(
      department: $department
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        employeeNo
        email
        firstName
        lastName
        department
        division
        line
        roles
        active
        id
        isAdmin
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderInspectionLog = /* GraphQL */ `
  query GetDgtPdOrderInspectionLog($id: ID!) {
    getDgtPdOrderInspectionLog(id: $id) {
      id
      productionOrderId
      workCenterId
      workCenterDescription
      machineId
      inspectionType
      inspectionStatus
      formName
      formUrl
      avgFwtByLots
      submittedDatetime
      submittedBy
      approvedDatetime
      approvedBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderInspectionLogs = /* GraphQL */ `
  query ListDgtPdOrderInspectionLogs(
    $filter: ModelDgtPdOrderInspectionLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdOrderInspectionLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        workCenterId
        workCenterDescription
        machineId
        inspectionType
        inspectionStatus
        formName
        formUrl
        avgFwtByLots
        submittedDatetime
        submittedBy
        approvedDatetime
        approvedBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderInspectionLogs = /* GraphQL */ `
  query SyncDgtPdOrderInspectionLogs(
    $filter: ModelDgtPdOrderInspectionLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderInspectionLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productionOrderId
        workCenterId
        workCenterDescription
        machineId
        inspectionType
        inspectionStatus
        formName
        formUrl
        avgFwtByLots
        submittedDatetime
        submittedBy
        approvedDatetime
        approvedBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const inspectionLogByOrderAndWc = /* GraphQL */ `
  query InspectionLogByOrderAndWc(
    $productionOrderId: String!
    $workCenterId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderInspectionLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inspectionLogByOrderAndWc(
      productionOrderId: $productionOrderId
      workCenterId: $workCenterId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        workCenterId
        workCenterDescription
        machineId
        inspectionType
        inspectionStatus
        formName
        formUrl
        avgFwtByLots
        submittedDatetime
        submittedBy
        approvedDatetime
        approvedBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdOrderReceipt = /* GraphQL */ `
  query GetDgtPdOrderReceipt($id: ID!) {
    getDgtPdOrderReceipt(id: $id) {
      id
      productionOrderId
      batchLotNo
      bulkUsage
      totalAmount
      avgFillingWeight
      retainedIssue
      microIssue
      validateIssue
      shelfLifeIssue
      testIssue
      otherIssue
      remark
      reject
      approvedByPdDate
      approvedByPdDatetime
      approvedByPdBy
      approvedByQcDate
      approvedByQcDatetime
      approvedByQcBy
      approvedByWhDate
      approvedByWhDatetime
      approvedByWhMonth
      approvedByWhBy
      approvedByFaDate
      approvedByFaDatetime
      approvedByFaBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      orderMaterialCode
      orderMaterialDesc
      orderType
      orderQty
      orderTags
      currentApprover
      isRework
      reworkedBy
      reworkedDatetime
      reworkNote
      otherIssueNote
      infoEaPerPack
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdOrderReceipts = /* GraphQL */ `
  query ListDgtPdOrderReceipts(
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDgtPdOrderReceipts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdOrderReceipts = /* GraphQL */ `
  query SyncDgtPdOrderReceipts(
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdOrderReceipts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const orderReceiptByOrder = /* GraphQL */ `
  query OrderReceiptByOrder(
    $productionOrderId: String!
    $batchLotNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderReceiptByOrder(
      productionOrderId: $productionOrderId
      batchLotNo: $batchLotNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const receiptByApprovedByPdDate = /* GraphQL */ `
  query ReceiptByApprovedByPdDate(
    $approvedByPdDate: AWSDate!
    $approvedByPdDatetime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receiptByApprovedByPdDate(
      approvedByPdDate: $approvedByPdDate
      approvedByPdDatetime: $approvedByPdDatetime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const receiptByApprovedByQcDate = /* GraphQL */ `
  query ReceiptByApprovedByQcDate(
    $approvedByQcDate: AWSDate!
    $approvedByQcDatetime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receiptByApprovedByQcDate(
      approvedByQcDate: $approvedByQcDate
      approvedByQcDatetime: $approvedByQcDatetime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const receiptByApprovedByWhDate = /* GraphQL */ `
  query ReceiptByApprovedByWhDate(
    $approvedByWhDate: AWSDate!
    $approvedByWhDatetime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receiptByApprovedByWhDate(
      approvedByWhDate: $approvedByWhDate
      approvedByWhDatetime: $approvedByWhDatetime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const receiptByApprovedByFaDate = /* GraphQL */ `
  query ReceiptByApprovedByFaDate(
    $approvedByFaDate: AWSDate!
    $approvedByFaDatetime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receiptByApprovedByFaDate(
      approvedByFaDate: $approvedByFaDate
      approvedByFaDatetime: $approvedByFaDatetime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const receiptByCurrentApprover = /* GraphQL */ `
  query ReceiptByCurrentApprover(
    $currentApprover: ReceiptApprover!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDgtPdOrderReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    receiptByCurrentApprover(
      currentApprover: $currentApprover
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productionOrderId
        batchLotNo
        bulkUsage
        totalAmount
        avgFillingWeight
        retainedIssue
        microIssue
        validateIssue
        shelfLifeIssue
        testIssue
        otherIssue
        remark
        reject
        approvedByPdDate
        approvedByPdDatetime
        approvedByPdBy
        approvedByQcDate
        approvedByQcDatetime
        approvedByQcBy
        approvedByWhDate
        approvedByWhDatetime
        approvedByWhMonth
        approvedByWhBy
        approvedByFaDate
        approvedByFaDatetime
        approvedByFaBy
        createdAt
        createdBy
        createdVersion
        updatedAt
        updatedBy
        updatedVersion
        orderMaterialCode
        orderMaterialDesc
        orderType
        orderQty
        orderTags
        currentApprover
        isRework
        reworkedBy
        reworkedDatetime
        reworkNote
        otherIssueNote
        infoEaPerPack
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDgtPdMovementReason = /* GraphQL */ `
  query GetDgtPdMovementReason($id: ID!) {
    getDgtPdMovementReason(id: $id) {
      id
      reasonCode
      reasonDesciption
      movementType
      componenType
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDgtPdMovementReasons = /* GraphQL */ `
  query ListDgtPdMovementReasons(
    $id: ID
    $filter: ModelDgtPdMovementReasonFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDgtPdMovementReasons(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        reasonCode
        reasonDesciption
        movementType
        componenType
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDgtPdMovementReasons = /* GraphQL */ `
  query SyncDgtPdMovementReasons(
    $filter: ModelDgtPdMovementReasonFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDgtPdMovementReasons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reasonCode
        reasonDesciption
        movementType
        componenType
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getMaterial = /* GraphQL */ `
  query GetMaterial($material_code: String) {
    getMaterial(material_code: $material_code)
  }
`;
export const getUserStatus = /* GraphQL */ `
  query GetUserStatus($username: String) {
    getUserStatus(username: $username)
  }
`;
export const syncMovementReasonsFromSap = /* GraphQL */ `
  query SyncMovementReasonsFromSap($mv_type: String) {
    syncMovementReasonsFromSap(mv_type: $mv_type) {
      id
      reasonCode
      reasonDesciption
      movementType
      componenType
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
